import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ApiProvider } from './contexts/ApiContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import DashboardPage from './pages/DashboardPage';
import Controls from './pages/Controls';
import Mapping from './pages/Mapping';
import Coverage from './pages/Coverage';
import Reports from './pages/Reports';
import Navigator from './pages/Navigator';
import './index.css';

// Protected Route wrapper
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <ApiProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Layout>
                  <Navigate to="/dashboard" />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Layout>
                  <DashboardPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/controls" element={
              <ProtectedRoute>
                <Layout>
                  <Controls />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/mapping" element={
              <ProtectedRoute>
                <Layout>
                  <Mapping />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/coverage" element={
              <ProtectedRoute>
                <Layout>
                  <Coverage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/reports" element={
              <ProtectedRoute>
                <Layout>
                  <Reports />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/navigator" element={
              <ProtectedRoute>
                <Layout>
                  <Navigator />
                </Layout>
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
      </ApiProvider>
    </AuthProvider>
  );
}

export default App;